{
    "NAME": "Elenco utentiLingua",
    "UsersList_Column_FullName": "Nome e cognome",
    "UsersList_Column_Username": "Nome utente",
    "UsersList_Column_LockOut": "Chiuso fuori",
    "UsersList_Column_ActivityLastLogon": "Attività\/Ultimo accesso",
    "UsersList_Tooltip_LastLogon_Label": "Ultimo accesso",
    "UsersList_LastLogon_None": "Nessun dato",
    "UsersList_Column_Permissions": "Autorizzazioni",
    "UsersList_Column_TelSys": "Server di telefonia",
    "UsersList_LockOut_Yes": "SÌ",
    "UsersList_LockOut_No": "NO",
    "UsersList_Filter_UserType_Label": "Tipo di utente",
    "UsersList_UserType_All": "Tutto",
    "UsersList_UserType_ServiceWide": "Ampia gamma di servizi",
    "UsersList_UserType_SystemWide": "a livello di sistema",
    "UsersList_UserType_Detached": "Distaccato",
    "UsersList_UserType_AdminInclusive": "Amministratori (inclusi)",
    "UsersList_UserType_AdminExclusive": "Amministratori (esclusivi)",
    "UsersList_UserType_ReportingHistoricOnly": "Resoconto (solo storico)",
    "UsersList_UserType_ReportingBLF": "Reportistica (BLF)",
    "UsersList_UserType_ReportingStd": "Reportistica (standard)",
    "UsersList_UserType_ReportingACD": "Segnalazione (ACD)",
    "UsersList_UserType_ReportingMobileAppAdvanced": "Reportistica (app mobile avanzata)",
    "UsersList_UserType_SignedInNow": "Ho effettuato l'accesso",
    "UsersList_UserType_SignedInToday": "Ho effettuato l'accesso oggi",
    "UsersList_UserType_SignedInThisWeek": "Registrato questa settimana",
    "UsersList_UserType_SignedInThisMonth": "Iscritto questo mese",
    "UsersList_UserType_SignedInNever": "Non ho mai effettuato l'accesso",
    "UsersList_UserType_ActivityToday": "Attività di oggi",
    "UsersList_UserType_ActivityThisWeek": "Attività di questa settimana",
    "UsersList_UserType_ActivityThisMonth": "Attività di questo mese",
    "UsersList_UserType_ActivityNone": "Nessuna attività",
    "UsersList_CopyReports_Button": "Copia dei rapporti a",
    "UsersList_BulkAdd_Button": "Aggiungi in blocco",
    "UsersList_SignInAs_Button": "Accedi come",
    "UsersList_SignInAs_Confirm": "Accedi come **{}**? Continuerai a utilizzare quell'utente in questa sessione del browser.",
    "UsersList_CopyReports_Dialog_Title": "Copia i report da **{} ({})**",
    "UsersList_CopyReports_Step_Reports": "Rapporti",
    "UsersList_CopyReports_Step_Targets": "Targetuser",
    "UsersList_CopyReports_Step_Confirm": "Confermare",
    "UsersList_CopyReports_Intro_Reports": "Seleziona uno o più report da copiare da **{}**.",
    "UsersList_CopyReports_Intro_Targets": "Seleziona uno o più utenti che devono ricevere copie di tali report.",
    "UsersList_CopyReports_Confirm_Summary": "Copierai il\/i report **{}** nell'utente\/negli utenti **{}**.",
    "UsersList_CopyReports_Confirm_Report_Label": "Copia del rapporto **{}**:",
    "UsersList_CopyReports_Confirm_Reports_Label": "Copia dei report **{}**:",
    "UsersList_CopyReports_Confirm_Target_Label": "All'utente **{}**:",
    "UsersList_CopyReports_Confirm_Targets_Label": "Agli utenti di **{}**:",
    "UsersList_CopyReports_Overwrite_Label": "Sostituire i report esistenti sugli utenti target in caso di conflitto di nomi.",
    "UsersList_CopyReports_Success": "Report copiati correttamente.",
    "UsersList_CopyReports_Cancel": "Cancellare",
    "UsersList_CopyReports_Back": "Indietro",
    "UsersList_CopyReports_Next": "Prossimo",
    "UsersList_CopyReports_Copy": "Rapporti di copia",
    "UsersList_CopyReports_Column_Folder": "Cartella",
    "UsersList_CopyReports_Column_ReportName": "Rapporto",
    "UsersList_CopyReports_Column_Type": "Tipo",
    "UsersList_CopyReports_Column_Username": "Nome utente",
    "UsersList_CopyReports_Column_FullName": "Nome e cognome",
    "UsersList_CopyReports_Empty_Reports": "Per questo utente non sono disponibili report da copiare.",
    "UsersList_CopyReports_Empty_Targets": "Non sono presenti utenti target idonei nell'ambito di questa operazione di copia."
}